/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9348b4de (Tue Jan 13 18:25:19 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  Playlist,
  PlaylistFromJSON,
  PlaylistItem,
  PlaylistItemFromJSON,
  PlaylistItemToJSON,
  PlaylistToJSON,
} from './'

/**
 *
 * @export
 * @interface FetchPlaylistResponse
 */
export interface FetchPlaylistResponse {
  /**
   *
   * @type Playlist
   * @memberof FetchPlaylistResponse
   */
  playlist: Playlist
  /**
   * List of playlist items belonging to the specified playlist
   * @type {Array<PlaylistItem>}
   * @memberof FetchPlaylistResponse
   */
  playlistItems: Array<PlaylistItem>
}

export function FetchPlaylistResponseFromJSON(
  json: any
): FetchPlaylistResponse {
  return FetchPlaylistResponseFromJSONTyped(json, false)
}

export function FetchPlaylistResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchPlaylistResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    playlist: PlaylistFromJSON(json['playlist']),
    playlistItems: (json['playlistItems'] as Array<any>).map(
      PlaylistItemFromJSON
    ),
  }
}

export function FetchPlaylistResponseToJSON(
  value?: FetchPlaylistResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    playlist: PlaylistToJSON(value.playlist),
    playlistItems: (value.playlistItems as Array<any>).map(PlaylistItemToJSON),
  }
}
